export class TemplateConfiguration {
  blockType!: string;
  templateId!: string;
  interface!: string;
  description!: string;
  channel!: string;
  startValue!: number;
  endValue!: number;
  order!: string;
  format!: string;
  deviceField!: string;
  timeZone!: string; 
  columnName!: string;
  inputValue!: number;
  stepValue!: number;
  carryForward!: boolean;
  cumulative!: boolean;
  latitude!: number;
  longitude!: number;
  latColumnName!: string;
  lngColumnName!: string;
  type!: string;
  trendSlope!: number;
  seasonalityAmplitude!: number;
  initialValue!: number;
  noiseLevel!: number;
  trendNoiseLevel!: number;
  lowerThreshold!: number;
  upperThreshold!: number;
  noOfDecimals!: number;
  fieldLength!: number;
}
